import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '../../config';
import { WeighbridgeTicket } from './weighbridge.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/weighbridge');

export const getWeighbridgeTicketList = actionCreator.async<
  { status: 'open' | 'processed'; daysBack?: number; endDate?: string },
  WeighbridgeTicket[]
>('GET_WEIGHBRIDGE_TICKET_LIST');
export const getWeighbridgeTicket = actionCreator.async<{}, WeighbridgeTicket>('GET_WEIGHBRIDGE_TICKET');
export const createWeigbridgeTicket = actionCreator.async<Partial<WeighbridgeTicket>, WeighbridgeTicket>(
  'CREATE_WEIGHBRIDGE_TICKET',
);
export const updateWeigbridgeTicket = actionCreator.async<WeighbridgeTicket, WeighbridgeTicket>(
  'UPDATE_WEIGHBRIDGE_TICKET',
);
export const deleteWeigbridgeTicket = actionCreator.async<string, {}>('DELETE_WEIGHBRIDGE_TICKET');

export const deleteSelectedWeighbridgeTickets = actionCreator.async<string[], {}>(
  'DELETE_SELECTED_WEIGHBRIDGE_TICKETS',
);

export const getWeighbridgeTicketTransactions = actionCreator.async<string, WeighbridgeTicket[]>(
  'GET_WEIGHTBRIDGE_TICKET_TRANSATIONS',
);
export const emptyWeighbridgeTicketsList = actionCreator<void>('EMPTY_WEIGHBRIDGE_TICKETS_LIST');
